import React, { useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createPlaceType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function PlaceTypeCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    placeTypeName: "",
    placeTypeDescription: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createPlaceType({
        ...form,
        companyId: COMPANY_ID,
        businessDomainId,
      });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/place-types`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("placeType.create.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("placeType.name")}
              name="placeTypeName"
              value={form.placeTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("placeType.description")}
              name="placeTypeDescription"
              value={form.placeTypeDescription}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.add")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/place-types`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
